// creating all factories here in a separate file is needed to get tree-shaking working
import * as allFactories from '../factoriesAny';
export var all = allFactories;


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/allFactoriesAny.js
// module id = 1334
// module chunks = 0